<script>
export default {
  name: 'CustomTooltip',
  props: {
    text: {
      type: String,
      required: true,
    },
    position: {
      type: String,
      default: 'top',
      validator(value) {
        return ['top', 'bottom', 'left', 'right'].includes(value)
      },
    },
    disable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hoverTimeout: null,
      autoHideTimeout: null,
      showTooltip: false,
    }
  },
  methods: {
    startHover() {
      if (this.disable) return
      this.hoverTimeout = setTimeout(() => {
        this.showTooltip = true
        this.startAutoHide()
      }, 1000)
    },
    stopHover() {
      if (this.disable) return
      clearTimeout(this.hoverTimeout)
      this.hideTooltip()
    },
    startFocus() {
      if (this.disable) return
      this.showTooltip = true
      this.startAutoHide()
    },
    stopFocus() {
      if (this.disable) return
      this.hideTooltip()
    },
    startAutoHide() {
      if (this.disable) return
      this.clearAutoHide()
      this.autoHideTimeout = setTimeout(() => {
        this.hideTooltip()
      }, 5000)
    },
    clearAutoHide() {
      clearTimeout(this.autoHideTimeout)
    },
    hideTooltip() {
      clearTimeout(this.hoverTimeout)
      clearTimeout(this.autoHideTimeout)
      this.showTooltip = false
    },
    handleClick(event) {
      this.$emit('click', event)
    },
  },
}
</script>

<template>
  <div
    class="tooltip-container"
    tabindex="0"
    @mouseenter="startHover"
    @mouseleave="stopHover"
    @focus="startFocus"
    @blur="stopFocus"
    @click="handleClick"
  >
    <slot />

    <transition name="fade">
      <div
        v-if="showTooltip && !disable"
        class="tooltip-box"
        :class="`tooltip-${position}`"
        @mouseenter="clearAutoHide"
        @mouseleave="startAutoHide"
      >
        {{ text }}
        <div class="tooltip-arrow" :class="`arrow-${position}`" />
      </div>
    </transition>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/_colors.scss';
@import '@/styles/bookingList/tooltip.scss';
</style>
